import loadable from '@loadable/component';
import { useTracking } from 'react-tracking';

import { usePortfolios } from '@/hooks/portfolio/usePortfolio';

import { OneColumn } from '@/components/Layout';
import DocumentHeader from '@/components/DocumentHeader';

const ErrorState = loadable(() => import('./ErrorState'), {
  resolveComponent: (c) => c.ErrorState,
});
const PopulatedState = loadable(() => import('./PopulatedState'), {
  resolveComponent: (c) => c.PopulatedState,
});

export const MyPortfolios = () => {
  const { Track } = useTracking({
    type: 'track',
    subject: 'page',
  });

  const { data: portfolios = [], status } = usePortfolios();

  if (status === 'pending') {
    return null;
  }

  if (status === 'error') {
    return (
      <Track>
        <DocumentHeader title="Portfolio Hub" />
        <OneColumn>
          <ErrorState />
        </OneColumn>
      </Track>
    );
  }

  return (
    <Track>
      <DocumentHeader title="Portfolio Hub" />
      <OneColumn>
        <PopulatedState portfolios={portfolios} />
      </OneColumn>
    </Track>
  );
};
